/** Fallback maximum video duration (used when plan limit is unavailable), in seconds (12 hours) */
export const MAX_VIDEO_DURATION_SECONDS = 12 * 60 * 60;

/** Maximum clip duration allowed, in seconds (20 minutes) */
export const MAX_CLIP_DURATION_SECONDS = 20 * 60;
